import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { BackfillProductsRequest } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/BackfillProducts.pb'
import { BackfillProductsResponse } from '@cash-web/shared-util-protos/squareup/cash/customersearch/api/BackfillProducts.pb'

export const backfillProducts = (request: BackfillProductsRequest, options?: CashRequestOptions) =>
  post<BackfillProductsRequest, BackfillProductsResponse>('/2.0/cash/backfill-products', request, {
    ...options,
    rejectOnError: true,
  })
